export default __webpack_public_path__ + "static/media/icon-info.b0b89a5d.svg";